<template>
  <DialogComponent
    :hashBase="hashBase"
    ref="dialog"
    :onOpening="onOpening"
    :onClosing="onClosing"
    :onOpened="onOpened"
    :onClosed="onClosed"
    :onBackButtonClick="onBackButtonClick"
    v-slot="{ data: { dialogIsVisible } }"
  >
    <div
      class="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      :class="{
        'pointer-events-all': dialogIsVisible,
        'pointer-events-none [&_*]:!pointer-events-none': !dialogIsVisible,
      }"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-30 transition-opacity dialogOverlay"
        :class="{
          'ease-out duration-100 opacity-100 ': dialogIsVisible,
          'ease-in duration-100 opacity-0 pointer-events-none':
            !dialogIsVisible,
        }"
      ></div>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center text-center sm:items-center"
        >
          <div
            class="absolute w-full h-full"
            @click="
              () => {
                if (onOverlayClick) onOverlayClick()
                else if (overlayerCanDismiss) hide()
              }
            "
          ></div>

          <div
            :class="{
              'ease-out duration-300 opacity-100 top-0 ': dialogIsVisible,
              'ease-in duration-200 opacity-0 top-4 sm:top-0 pointer-events-none dialogNotVisible scale-[0.8]':
                !dialogIsVisible,
            }"
            class="boxComponent rounded-[2.5rem] relative overflow-hidden text-left transition-all sm:my-8 max-w-[90%] sm:w-[max-content] inline-block"
          >
            <div
              class="boxComponent rounded-[2.5rem] bg-white absolute w-full h-full z-[0]"
            ></div>

            <div class="w-full h-full relative">
              <div class="flex justify-end w-full">
                <div
                  v-if="dialogIsVisible"
                  @click="hide"
                  class="cursor-pointer modalCloseButton relative top-4 w-[4rem] px-3 pr-5 text-3xl"
                >
                  <ColorImg
                    src="/images/required/close_modal.svg"
                    class="h-full bg-[#2c2c2c]"
                    alt=""
                  />
                </div>
              </div>
              <div v-if="dialogIsVisible || keepContentAlive">
                <div class="sm:flex sm:items-start">
                  <div class="sm:text-left">
                    <slot
                      name="header"
                      v-if="
                        $slots.header ||
                        $slots.titleContainer ||
                        $slots.titleText
                      "
                    >
                      <div class="mb-4">
                        <slot
                          name="titleContainer"
                          v-if="$slots.titleContainer || $slots.titleText"
                        >
                          <span
                            v-if="$slots.titleText"
                            class="text-center p-4 text-3xl md:text-2xl block font-bold title-color"
                            ><slot name="titleText"></slot
                          ></span>
                        </slot>
                        <div
                          class="py-2"
                          v-if="$slots.subtitleContainer || $slots.subtitleText"
                        ></div>
                        <slot
                          name="subtitleContainer"
                          v-if="$slots.subtitleContainer || $slots.subtitleText"
                        >
                          <span
                            class="textComponent text-center px-4 block description-color"
                            ><slot name="subtitleText"></slot
                          ></span>
                        </slot>
                        <slot name="banner"> </slot>
                      </div>
                    </slot>

                    <slot name="fullContent">
                      <div class="max-h-[80dvh] overflow-auto">
                        <div class="">
                          <slot></slot>
                        </div>
                      </div>
                    </slot>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  dialogIsVisible &&
                  (!!$slots.primaryButton || !!$slots.cancelButton)
                "
                class="px-4 py-3 flex sm:px-6 gap-3"
                :class="{ 'flex-row-reverse': buttonsToRight }"
              >
                <button
                  class="p-4 ripple"
                  v-if="!!$slots.primaryButton"
                  @click="onPrimaryClick"
                  :loading="primaryButtonLoading"
                >
                  <span class="title-color">
                    <slot name="primaryButton"></slot>
                  </span>
                </button>
                <button
                  class="p-4 ripple"
                  v-if="!!$slots.cancelButton"
                  @click="
                    () => {
                      if (onCancelClick) onCancelClick()
                      else hide()
                    }
                  "
                >
                  <span class="title-color">
                    <slot name="cancelButton"></slot>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue'
import DialogComponent from './DialogComponent.vue'
import ColorImg from '../img/ColorImg.vue'

export default defineComponent({
  components: { DialogComponent, ColorImg },
  props: {
    onOpening: { type: Function, default: () => {} },
    onClosing: { type: Function, default: () => {} },
    onOpened: { type: Function, default: () => {} },
    onClosed: { type: Function, default: () => {} },
    onBackButtonClick: { type: Function, default: null },

    onPrimaryClick: {
      type: Function,
      default: () => {},
    },
    onOverlayClick: {
      type: Function,
      default: null,
    },
    onCancelClick: {
      type: Function,
      default: null,
    },
    overlayerCanDismiss: {
      type: Boolean,
      default: true,
    },
    buttonsToRight: {
      type: Boolean,
      default: true,
    },
    primaryButtonLoading: {
      type: Boolean,
      default: false,
    },
    keepContentAlive: {
      type: Boolean,
      default: false,
    },
    hashBase: {
      type: String,
      default: 'modalvisible',
    },
  },
  methods: {
    show() {
      this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog.hide()
    },
    isVisible() {
      return this.$refs.dialog.isVisible()
    },
  },
})
</script>
